import type React from 'react'

interface DotsIndicatorProps {
  total: number
  currentIndex: number
  onDotClick?: (index: number) => void
}

const DotsIndicator: React.FC<DotsIndicatorProps> = ({ total, currentIndex, onDotClick }) => {
  return (
    <div className="dots-indicator">
      {Array.from({ length: total }).map((_, index) => (
        <span key={index} className={`dot ${index === currentIndex ? 'active' : ''}`} onClick={() => onDotClick?.(index)} />
      ))}
    </div>
  )
}

export default DotsIndicator
